import React from "react";
import * as Styled from "./Style";

const Loader = (props) => {
  return (
    <Styled.LoaderStyle className={"loader-wrapper " + props.classes}>
      <div className="">
        {/* <div className="dot-loader"></div>
        <div className="dot-loader dot-loader--2"></div>
        <div className="dot-loader dot-loader--3"></div> */}
        <div className="nb-spinner"></div>
      </div>
    </Styled.LoaderStyle>
  );
};

export default Loader;
